"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Col = exports.offsets = exports.sizes = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.sizes = {
    S: 'sizeS',
    M: 'sizeM',
    L: 'sizeL',
    XL: 'sizeXL',
};
exports.offsets = {
    S: 'offsetS',
    M: 'offsetM',
    L: 'offsetL',
    XL: 'offsetXL',
};
/**
 * Блок для размещения контента или строк (``Row``) внутри себя.
 */
exports.Col = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    box-sizing: border-box;\n\n    padding-left: var(--plasma-grid-gutter);\n    padding-right: var(--plasma-grid-gutter);\n"], ["\n    box-sizing: border-box;\n\n    padding-left: var(--plasma-grid-gutter);\n    padding-right: var(--plasma-grid-gutter);\n"])));
var templateObject_1;
//# sourceMappingURL=Col.js.map